import { initializeApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const isLocalhost =
  typeof window !== 'undefined' && ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
const isE2EMockAuth = process.env.REACT_APP_E2E_MOCK_AUTH === 'true' && isLocalhost;

// Initialize Firebase unless we're in E2E mock mode.
//
// In CI/screenshot tests we intentionally avoid requiring real Firebase config,
// so we must not initialize Auth at module-load time.
const app = isE2EMockAuth ? (null as any) : initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth: Auth = isE2EMockAuth ? ({} as Auth) : getAuth(app);
export default app;
